import * as React from 'react';

import { cn } from '../../lib/utils';

function Input({ className, variant = 'primary', type, ...props }) {
    return (
        <input
            type={type}
            data-slot="input"
            className={cn(
                `tw-shadow-xs tw-flex tw-h-9 tw-w-full tw-min-w-0 tw-rounded-md tw-border tw-border-input tw-bg-transparent tw-px-3 tw-py-1 tw-text-base tw-outline-none tw-transition-[color,box-shadow] selection:tw-bg-primary-theme selection:tw-text-primary-foreground file:tw-inline-flex file:tw-h-7 file:tw-border-0 file:tw-bg-transparent file:tw-text-sm file:tw-font-medium file:tw-text-foreground placeholder:tw-text-muted-foreground disabled:tw-pointer-events-none disabled:tw-cursor-not-allowed disabled:tw-opacity-50 md:tw-text-sm`,
                variant === 'default'
                    ? 'focus-visible:tw-border-ring focus-visible:tw-ring-[3px] focus-visible:tw-ring-ring/50'
                    : 'focus-visible:tw-border-[2px] focus-visible:tw-border-primary-theme focus-visible:tw-ring-[2px] focus-visible:tw-ring-primary-theme-foreground',
                'aria-invalid:tw-ring-destructive/20 dark:aria-invalid:tw-ring-destructive/40 aria-invalid:tw-border-destructive',
                className
            )}
            {...props}
        />
    );
}

export { Input };
